import { QueryClient, useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { projectsKeys } from '../projectsKeys'
import { PageResponse } from '@core/entities/pagination'
import { IProjectSummary } from '@core/entities/project'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { ProjectSummary } from '@core/entities/project/ProjectSummary/ProjectSummary'

const dataTransformer = ({ content }: PageResponse<IProjectSummary>) =>
  content.map((project) => ProjectSummary.new(project))

export const useGetAllProjects = (
  payload: RequestTypes['getAllProjects'],
  options?: UseQueryOptions<
    PageResponse<IProjectSummary>,
    RequestErrorType,
    Array<ProjectSummary>
  >,
) => {
  return useQuery({
    select: dataTransformer,
    ...projectsKeys.getAllProjects(payload),
    ...options,
  })
}

export const prefetchGetAllProjects = (
  queryClient: QueryClient,
  payload: RequestTypes['getAllProjects'],
  options?: UseQueryOptions<
    PageResponse<IProjectSummary>,
    RequestErrorType,
    Array<ProjectSummary>
  >,
) => {
  return queryClient.prefetchQuery({
    select: dataTransformer,
    ...projectsKeys.getAllProjects(payload),
    ...options,
    cacheTime: Infinity,
  })
}
